import { IAppointment } from "../types/appointments.types";

/**
 * The name a calendar card carries under the patient.
 *
 * For a device session that is the machine, not the technician: the machine is what the session is
 * booked on and what the staff look for on the board, while the technician is whoever is on shift
 * and changes between appointments. Everything else keeps showing the therapist.
 */
export function getAppointmentOwnerName(appointment: IAppointment): string {
  const deviceName = appointment.device?.deviceName;
  if (appointment.device && deviceName) return deviceName;
  return appointment.therapistName || "";
}
